export default {"src":"/_next/static/media/clock.4e520de8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};